import React, { useEffect, useState } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import SortBuy from '../../components/dropdown/SortBuy'
import { Link } from 'react-router-dom'
import axios from '../../API/axios'

const FollowedCompany = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [companyList, setCompanyList] = useState([]);
    const [searchCompanyList, setSearchCompanyList] = useState([]);
    const [nextBatchLoading, setNextBatchLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    const [searchUserName, setSearchUserName] = useState("");
  
    const getCompanyList = (page = 1, searchUserName = "") => {
      const data = {
        deviceType: "Web",
        pageNumber: page,
        pageSize: 24,
      };
  
      axios
        .post(`Company/GetAllCompaniesList?Search=${searchUserName}`, data)
        .then((response) => {
          console.log("company list====>",response.data.responseData.companiesList);
          
          const newPosts = response.data.responseData.companiesList;
          setIsLoading(false);
          setTotalPages(response.data.responseData.paging.totalPages);
  
          if (searchUserName !== "") {
            setCompanyList([]);
            setSearchCompanyList(newPosts);
          } else {
            setSearchCompanyList([]);
            setCompanyList((prev) => {
              const postSet = new Set(prev?.map((post) => post?.compUid));
              const uniqueNewPosts = newPosts.filter(
                (post) => !postSet.has(post?.compUid)
              );
              return [...prev, ...uniqueNewPosts];
            });
          }
  
          setNextBatchLoading(page < totalPages);
        })
        .catch(() => {
          setIsLoading(false);
          setNextBatchLoading(false);
        });
    };
  
    useEffect(() => {
      getCompanyList(); // Initial fetch on mount
    }, []);

  return (
    <>
     {/* <section className={`inner-employer-section ${className} container` }> */}
      <div className="container pb-5">
        <Tabs className="col-lg-12 tf-tab">
          <div className="wd-meta-select-job">
            <div className="wd-findjob-filer">
              <div className="group-select-display">
                {/* <TabList className="inner menu-tab">
                  <Tab className="btn-display">
                    <svg  ></svg>
                  </Tab>
                  <Tab className="btn-display">
                    <svg  ></svg>
                  </Tab>
                </TabList> */}
                <h6 className="">
                  <span>1249</span> employers recommended for you
                </h6>
              </div>
              {/* <SortBuy /> */}
            </div>
          </div>
          <div className="content-tab">
            {/* Tab content for employer listings */}
            <TabPanel className="inner">
              <div className="group-col-2">
                {companyList.map((company) => (
                  <div key={company.compUid} className="employer-block style-2 cl2">
                    <div className="inner-box">
                      <div className="logo-company">
                        <img src={company.logoImage} alt="jobtex" />
                      </div>
                      <div className="box-content">
                        <div className="star">{/* Star ratings */}</div>
                        <h3>
                        <Link to={`/Employersingle_v1/${company.compUid}`}>{company.compName}</Link>
                        
                        </h3>
                        <p className="info">
                          {/* <span className="icon-map-pin"></span> */}
                          {company.industryName}
                        </p>
                      </div>
                      <div className="button-readmore">
                        {/* <span className="icon-heart"></span> */}
                        <button className="btn-employer">
                          {/* {company.jobType} */}
                          Follow
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
 
            </TabPanel>
          </div>
        </Tabs>
      </div>
    {/* </section> */}
    </>
  )
}

export default FollowedCompany